module.exports = __webpack_public_path__ + "assets/images/scrolly-v2/mobile.svg?v=07fb6ce3";